/**
 * @generated SignedSource<<0fc0d2bc18f3d6bbf3c3a349cbcf7d79>>
 * @relayHash 527de7e758fda6cab12256d50228119d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 527de7e758fda6cab12256d50228119d

import { ConcreteRequest } from 'relay-runtime';
export type Ch_updateProgressNoteCareProviderInput = {
  id: string;
  isWithin24HoursAfterClose: boolean;
  newCareProviderId: string;
};
export type useChUpdateProgressNoteCareProviderMutation$variables = {
  input: Ch_updateProgressNoteCareProviderInput;
};
export type useChUpdateProgressNoteCareProviderMutation$data = {
  readonly ch_updateProgressNoteCareProvider: {
    readonly ch_ProgressNoteMutationOutput: {
      readonly progressNote: {
        readonly id: string;
        readonly pointOfCare: {
          readonly careProvider: {
            readonly businessName: string | null;
            readonly firstName: string | null;
            readonly id: string;
            readonly lastName: string | null;
          } | null;
          readonly careProviderId: number | null;
        } | null;
        readonly updatedAt: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChUpdateProgressNoteCareProviderMutation = {
  response: useChUpdateProgressNoteCareProviderMutation$data;
  variables: useChUpdateProgressNoteCareProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ProgressNoteMutationOutput",
  "kind": "LinkedField",
  "name": "ch_ProgressNoteMutationOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_PointOfCare",
          "kind": "LinkedField",
          "name": "pointOfCare",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "careProviderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CareProvider",
              "kind": "LinkedField",
              "name": "careProvider",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "businessName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChUpdateProgressNoteCareProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteCareProviderPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteCareProvider",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChUpdateProgressNoteCareProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteCareProviderPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteCareProvider",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "527de7e758fda6cab12256d50228119d",
    "metadata": {},
    "name": "useChUpdateProgressNoteCareProviderMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2bb26f64e9d1be6d27c3d3cf2420b2ee";

export default node;
